import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {ActivityIndicator, TouchableOpacity, View} from 'react-native';
import {Text} from '../../../globalComponents/NativeOverrides';
import { LeagueProps, TournamentProps } from '../../../store/types/sr_svc';
import { event_getTournamentByTournamentId } from '../../../store/actionsv1/events';
import { useIsInViewport } from '../../../utilsv1/helpers';
import Colors from '../../../constants/Colorsv2';
import { market_getLatestTradesByEventId } from '../../../store/actionsv1/markets';
import { Icon } from 'react-native-elements';


type TournamentCardProps = {
    navigation: any,
    tournament_id:string,
}

const TournamentCard = ({ navigation, tournament_id }:TournamentCardProps) => {
    const [ tournament_loaded, setTournamentLoaded ] = useState(false)
    const dispatch = useDispatch()
    const tournament = useSelector((state:any) => state.event.tournaments[tournament_id], (left, right) => { 
        if(left.tournament_id != right.tournament_id){ return false }
        return true
    })


    const leagues:LeagueProps[] = useSelector((state:any) => state.event.leagues, (left, right) => left.length === right.length)
    
    const tournament_ref = useRef()
    const isInViewport1 = useIsInViewport(tournament_ref)

    useEffect(() => {
        if(!tournament_loaded && isInViewport1){
            getTournamentDetailsFromServer(tournament_id)
        }
    },[isInViewport1])


    const getTournamentDetailsFromServer = async(tournament_id:string) => {
        if(!tournament){ dispatch(await event_getTournamentByTournamentId(tournament_id)) }
        setTournamentLoaded(true)
    }

    

    const league = leagues.find(l => l.league_id == tournament?.league_id)
    if(!league){ return <></> }
    return (
        <TouchableOpacity ref={tournament_ref} style={styles.cardStyle} onPress={() => { 
                if(['PGA','UFC'].includes(league.league_name)){ return navigation.push('Tournament2', { tournament_id: tournament.tournament_id, league_id:league.league_id }) }
                return navigation.push('Tournament2', { tournament_id: tournament.tournament_id, league_id: league.league_id })
            }}>
            { !tournament_loaded ?
            <View style={{ height:100 }} />
            :
            <View>
                {tournament ?
                <View style={{ flexDirection:'row' }}>
                    <View style={{ flex:1 }}>
                        <View nativeID="info" style={{ flexDirection:'row' }}>
                            <Text size={12} color={Colors.shades.black} weight='semibold'>{league?.league_name} - {tournament.time_detail}</Text>
                        </View>
                        <View>
                            <Text size={14} color={Colors.brand.midnight} weight='bold'>{tournament.tournament_name}</Text>
                        </View>
                    </View>
                    <View>
                        <Icon name='chevron-right' type='feather' color={Colors.brand.midnight} />
                    </View>
                </View>
                :<></>}
            </View>
            }
        </TouchableOpacity>
    )
}

const styles = {
    cardStyle: { padding:7, borderRadius: 12, borderWidth: 1, borderColor: Colors.shades.shade400 }
}


export default TournamentCard